(function () {
  // =========================
  // Helpers
  // =========================

  function onProductPage() {
    const main = document.querySelector('main#MainContent');
    const tpl = main?.getAttribute('data-template') || '';
    return tpl.startsWith('product');
  }

  function normImgUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      u.search = '';
      return u.toString();
    } catch (e) {
      return (url || '').split('?')[0];
    }
  }

  function getClickedGalleryMediaId(target) {
    const node = target.closest('[data-media-id]');
    return node?.dataset?.mediaId || null;
  }

  function buildGallerySrcMap() {
    const map = new Map();
    const items = document.querySelectorAll(
      '.media-gallery__grid > li, .media-gallery__grid li, ul.media-gallery__grid > li'
    );

    items.forEach((li) => {
      const mediaId = li.querySelector('[data-media-id]')?.dataset?.mediaId;
      const img = li.querySelector('img');
      if (!mediaId || !img) return;

      const src = normImgUrl(img.currentSrc || img.src);
      if (src) map.set(src, mediaId);
    });

    return map;
  }

  async function fetchProductJson() {
    const url = window.location.pathname.replace(/\/$/, '') + '.js';
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Produkt-JSON konnte nicht geladen werden: ' + res.status);
    return await res.json();
  }

  async function buildMediaToVariantMap() {
    const product = await fetchProductJson();

    const gallerySrcToMediaId = buildGallerySrcMap();
    const mediaToVariant = new Map();

    (product.variants || []).forEach((v) => {
      const variantId = String(v.id);

      const directMediaId =
        v.featured_media?.id ||
        v.featured_media?.media_id ||
        v.featured_media_id ||
        v.featured_media?.mediaId;

      if (directMediaId) {
        mediaToVariant.set(String(directMediaId), variantId);
        return;
      }

      const featuredSrc = v.featured_image?.src || v.featured_image || v.featured_media?.src;
      if (!featuredSrc) return;

      const normFeatured = normImgUrl(featuredSrc);
      const mediaIdFromSrc = gallerySrcToMediaId.get(normFeatured);
      if (mediaIdFromSrc) {
        mediaToVariant.set(String(mediaIdFromSrc), variantId);
      }
    });

    return mediaToVariant;
  }

  // =========================
  // Variant-ID zuverlässig setzen (richtiger Scope)
  // =========================

  function findScopeRoot(fromElement) {
    // Wir nehmen bewusst product-form-component oder buy-buttons-block,
    // weil Horizon dort zuverlässig Form + Button gerendert hat.
    return (
      fromElement?.closest('product-form-component') ||
      fromElement?.closest('.buy-buttons-block') ||
      document.querySelector('product-form-component') ||
      document.querySelector('.buy-buttons-block') ||
      document
    );
  }

  function setVariantIdInScope(scopeRoot, variantId) {
    const forms = scopeRoot.querySelectorAll('form[action*="/cart/add"]');
    if (!forms || forms.length === 0) return false;

    let did = false;

    forms.forEach((form) => {
      let idInput = form.querySelector('input[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        form.appendChild(idInput);
      }

      const before = String(idInput.value || '');
      const next = String(variantId);

      if (before !== next) {
        idInput.value = next;

        // Theme/Components "aufwecken"
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        form.dispatchEvent(new Event('change', { bubbles: true }));

        did = true;
      }
    });

    return did;
  }

  function selectVariantControlIfPresent(variantId) {
    // Wenn Horizon Radio/Swatch Inputs hat, lassen wir das Theme "normal" schalten.
    // Dadurch werden Preis/Availability/Media-state etc. konsistent.
    const selector = `input[data-variant-id="${CSS.escape(String(variantId))}"]`;
    const input = document.querySelector(selector);
    if (!input) return false;

    // "echtes" Verhalten: checked setzen + Events
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // zusätzlich click, weil manche Implementierungen nur darauf hören
    try {
      input.click();
    } catch (e) {
      // ignore
    }

    return true;
  }

  function applyVariantFromAnySource(fromElement, variantId) {
    const scopeRoot = findScopeRoot(fromElement);
    // 1) Theme-Controls (wenn vorhanden)
    selectVariantControlIfPresent(variantId);

    // 2) Unbedingt die hidden Variant-ID in der/den cart/add Form(en) setzen
    //    (das ist das, was Shopify wirklich addet)
    setVariantIdInScope(scopeRoot, variantId);

    // 3) Manche Themes überschreiben das hidden input nach dem UI-Change asynchron.
    //    Daher nachsetzen (kurz).
    setTimeout(() => setVariantIdInScope(scopeRoot, variantId), 0);
    setTimeout(() => setVariantIdInScope(scopeRoot, variantId), 50);

    return true;
  }

  // =========================
  // VariantSync (Galerie -> Variante)
  // =========================

  if (onProductPage()) {
    window.__variantSyncLoaded = true;
    console.log('[VariantSync] loaded');

    let mediaToVariantMap = null;
    let building = null;

    async function ensureMap() {
      if (mediaToVariantMap) return mediaToVariantMap;
      if (building) return building;

      building = (async () => {
        const map = await buildMediaToVariantMap();
        mediaToVariantMap = map;
        console.log('[VariantSync] init done, mapped entries:', map.size);

        const sample = [];
        let i = 0;
        for (const [mediaId, variantId] of map.entries()) {
          sample.push({ mediaId, variantId });
          if (++i >= 6) break;
        }
        console.log('[VariantSync] sample media->variant:', sample);

        return map;
      })();

      return building;
    }

    async function onGalleryClick(e) {
      const target = e.target;
      if (!target) return;

      const inGallery = target.closest('.media-gallery__grid, media-gallery, .media-gallery');
      if (!inGallery) return;

      const mediaId = getClickedGalleryMediaId(target);
      if (!mediaId) return;

      const map = await ensureMap();
      const variantId = map.get(String(mediaId)) || null;

      console.log('[VariantSync] gallery mediaId:', mediaId, '=> variantId:', variantId);
      if (!variantId) return;

      applyVariantFromAnySource(target, variantId);
    }

    // Capture-Phase
    document.addEventListener('click', onGalleryClick, true);
  }
})();

(function () {
  // =========================
  // SKU/Variant line updater (dein bestehender Code)
  // =========================
  const main = document.querySelector('main#MainContent');
  const tpl = main?.getAttribute('data-template') || '';
  if (!tpl.startsWith('product')) return;

  function parseVariants() {
    const el = document.querySelector('[data-variants-json]');
    if (!el) return null;
    try {
      const variants = JSON.parse(el.textContent || '[]');
      const map = new Map();
      variants.forEach((v) => map.set(String(v.id), v));
      return map;
    } catch (e) {
      return null;
    }
  }

  const variantsMap = parseVariants();
  if (!variantsMap) return;

  function updateLine(variantId) {
    const v = variantsMap.get(String(variantId));
    if (!v) return;

    const line = document.querySelector('[data-current-variant-line]');
    const titleEl = document.querySelector('[data-current-variant-title]');
    if (!line || !titleEl) return;

    titleEl.textContent = v.title || '';

    let skuEl = document.querySelector('[data-current-variant-sku]');
    const sku = (v.sku || '').trim();

    if (sku) {
      if (!skuEl) {
        skuEl = document.createElement('span');
        skuEl.className = 'current-variant-sku';
        skuEl.setAttribute('data-current-variant-sku', '');
        line.appendChild(skuEl);
      }
      skuEl.textContent = `– ${sku}`;
    } else {
      if (skuEl) skuEl.remove();
    }
  }

  document.addEventListener(
    'change',
    (e) => {
      const input = e.target;
      if (!input) return;

      if (input.matches('input[type="radio"][data-variant-id]')) {
        updateLine(input.getAttribute('data-variant-id'));
      }
    },
    true
  );
})();

(function () {
  // =========================
  // Variant current line (dein bestehender Code, leicht stabilisiert)
  // =========================
  function onProductPage() {
    const main = document.querySelector('main#MainContent');
    return main && String(main.getAttribute('data-template') || '').startsWith('product');
  }

  function initVariantCurrentLine() {
    if (!onProductPage()) return;

    const picker = document.querySelector('variant-picker');
    if (!picker) return;

    const out = picker.querySelector('[data-variant-current]');
    const outTitle = picker.querySelector('[data-variant-current-title]');
    const variantsScript = picker.querySelector('script[data-variants-json]');
    if (!out || !outTitle || !variantsScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (e) {
      return;
    }

    function getCurrentVariantId() {
      const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return idInput ? String(idInput.value || '') : '';
    }

    function render() {
      const id = getCurrentVariantId();
      if (!id) return;

      const v = variants.find((x) => String(x.id) === id);
      if (!v) return;

      outTitle.textContent = v.public_title || v.title || '';

      const sku = (v.sku || '').trim();
      let outSku = picker.querySelector('[data-variant-current-sku]');
      if (sku) {
        if (!outSku) {
          outSku = document.createElement('span');
          outSku.className = 'variant-picker__current-sku';
          outSku.setAttribute('data-variant-current-sku', '');
          out.appendChild(outSku);
        }
        outSku.textContent = `— ${sku}`;
        outSku.style.display = '';
      } else {
        if (outSku) outSku.style.display = 'none';
      }
    }

    render();

    picker.addEventListener('change', render, true);

    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const mo = new MutationObserver(() => render());
      mo.observe(form, { subtree: true, childList: true, attributes: true });
    }
  }

  document.addEventListener('DOMContentLoaded', initVariantCurrentLine);
})();

(function () {
  // =========================
  // Form ID Fix (stabil, ohne Debug-Noise)
  // =========================

  if (!document.querySelector('product-form-component')) return;

  const CART_ADD_RE = /\/cart\/add(\.js)?/i;

  function desiredId(pfc) {
    return (
      pfc.getAttribute('data-form-id') ||
      pfc.getAttribute('data-product-form-id') ||
      pfc.getAttribute('form-id') ||
      ''
    ).trim();
  }

  function findCartAddForm(root) {
    const forms = [...root.querySelectorAll('form')];
    return forms.find((f) => {
      const action = f.getAttribute('action') || '';
      return CART_ADD_RE.test(action);
    });
  }

  function fixOne(pfc) {
    const want = desiredId(pfc);
    if (!want) return;

    const form = findCartAddForm(pfc) || findCartAddForm(pfc.closest('.buy-buttons-block') || pfc);
    if (!form) return;

    if (form.id !== want) form.id = want;

    const root = pfc.closest('.buy-buttons-block') || pfc;
    root.querySelectorAll('button[type="submit"][name="add"]').forEach((btn) => {
      if (btn.getAttribute('form') !== want) btn.setAttribute('form', want);
    });
  }

  function fixAll() {
    document.querySelectorAll('product-form-component').forEach(fixOne);
  }

  const run = () => {
    fixAll();
    setTimeout(fixAll, 250);
    setTimeout(fixAll, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  let scheduled = false;
  const obs = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fixAll();
    });
  });

  obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true });
})();
// --- Final Variant Guard: always submit the currently selected variant ---
(() => {
  function getVariantIdFromUrl() {
    const p = new URLSearchParams(window.location.search);
    const v = p.get('variant');
    return v ? String(v) : '';
  }

  function getVariantIdFromPicker(scope) {
    // 1) checked swatch/radio
    const checked = scope.querySelector('input[data-variant-id]:checked');
    if (checked?.getAttribute('data-variant-id')) return String(checked.getAttribute('data-variant-id'));

    // 2) select[name="id"] (classic)
    const sel = scope.querySelector('select[name="id"]');
    if (sel?.value) return String(sel.value);

    // 3) hidden input[name="id"] already there
    const hidden = scope.querySelector('input[name="id"]');
    if (hidden?.value) return String(hidden.value);

    return '';
  }

  function setFormVariantId(form, variantId) {
    if (!form || !variantId) return false;

    let idInput = form.querySelector('input[name="id"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      form.appendChild(idInput);
    }

    const before = String(idInput.value || '');
    if (before === String(variantId)) return true;

    idInput.value = String(variantId);

    // wake up theme listeners
    idInput.dispatchEvent(new Event('input', { bubbles: true }));
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    form.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }

  function findCartAddForm(scope) {
    return [...scope.querySelectorAll('form')].find((f) => {
      const action = (f.getAttribute('action') || '').toLowerCase();
      return action.includes('/cart/add');
    });
  }

  // capture-phase: runs BEFORE Horizon handlers
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target?.closest('button[type="submit"][name="add"], [ref="addToCartButton"]');
      if (!btn) return;

      const scope =
        btn.closest('product-form-component') ||
        btn.closest('.buy-buttons-block') ||
        document.querySelector('product-form-component') ||
        document;

      const form = findCartAddForm(scope);
      if (!form) return;

      // source of truth: URL variant param if present, else picker state
      const variantId = getVariantIdFromUrl() || getVariantIdFromPicker(scope);
      if (!variantId) return;

      setFormVariantId(form, variantId);
    },
    true
  );
})();
(function () {
  // =========================
  // Hide inventory + ATC when option value === "Produktbild"
  // (NO cart functionality touched)
  // =========================

  function onProductPage() {
    const main = document.querySelector('main#MainContent');
    return main && String(main.getAttribute('data-template') || '').startsWith('product');
  }

  if (!onProductPage()) return;

  const inventoryEl = document.querySelector('product-inventory.product-inventory');
  const buyButtonsBlock = document.querySelector('span.buy-buttons-block');

  if (!inventoryEl && !buyButtonsBlock) return;

  function setHidden(hidden) {
    if (inventoryEl) inventoryEl.style.display = hidden ? 'none' : '';
    if (buyButtonsBlock) buyButtonsBlock.style.display = hidden ? 'none' : '';
  }

  function selectedValuesFromPicker(picker) {
    if (!picker) return [];

    // checked inputs (radio/swatch)
    const checkedInputs = Array.from(picker.querySelectorAll('input:checked'))
      .map((el) => el.value)
      .filter(Boolean);

    // selected options from selects
    const selectedOptions = Array.from(picker.querySelectorAll('select option:checked'))
      .map((el) => el.value || el.textContent)
      .filter(Boolean);

    return [...checkedInputs, ...selectedOptions].map((v) => String(v).trim());
  }

  function isProduktbildSelected() {
    const picker = document.querySelector('variant-picker');
    const vals = selectedValuesFromPicker(picker);
    return vals.includes('Produktbild');
  }

  function sync() {
    setHidden(isProduktbildSelected());
  }

  // initial
  sync();

  // react to picker changes (safe, does not touch cart/add)
  document.addEventListener(
    'change',
    (e) => {
      if (!e.target) return;
      if (!e.target.closest('variant-picker')) return;
      sync();
    },
    true
  );

  // if theme fires variant:change with detail.variant
  document.addEventListener('variant:change', (e) => {
    const v = e?.detail?.variant;
    if (!v) return sync();

    const vals = [v.title, v.option1, v.option2, v.option3]
      .filter(Boolean)
      .map((x) => String(x).trim());

    setHidden(vals.includes('Produktbild'));
  });

  // safety: if theme updates hidden input id without triggering picker change
  const form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    const mo = new MutationObserver(() => sync());
    mo.observe(form, { subtree: true, childList: true, attributes: true });
  }
})();

